export const MODELS = [
  { id: "claude", label: "Claude Sonnet 5.5", hint: "Most natural writing (recommended)" },
  { id: "gpt", label: "GPT 5.6", hint: "Fast and sharp" },
  { id: "gemini", label: "Gemini 3.1 Pro", hint: "Thorough reasoning" },
  { id: "gemini-flash", label: "Gemini 3 Flash", hint: "Quickest" },
];

export const STEPS = [
  { n: 1, label: "Your CV", short: "CV" },
  { n: 2, label: "The job", short: "Job" },
  { n: 3, label: "Compatibility", short: "Fit" },
  { n: 4, label: "Improve", short: "Improve" },
  { n: 5, label: "Preview & download", short: "Download" },
  { n: 6, label: "Track", short: "Track" },
];

export const KESH_HELP = {
  1: { tip: "Upload the CV you already have. Clear headings like Experience, Education and Skills help ATS software read it.", ask: ["What makes a good CV?", "Which file type should I upload?"] },
  2: { tip: "Paste the whole ad, including the requirements. The more we can read, the more honest your match score.", ask: ["How do I spot a fake job ad?", "Which AI should I pick?"] },
  3: { tip: "Look at the must-haves first, like a degree or licence. If one is missing from your CV, your match is capped at 60% until you confirm you meet it.", ask: ["Explain my compatibility score", "What does the 60% cap mean?"] },
  4: { tip: "We put the job ad's keywords and tools into your CV. Ask for any change in plain words and we'll rewrite it straight away.", ask: ["How do I beat ATS filters?", "How can I make my bullet points stronger?"] },
  5: { tip: "Most employers accept PDF. Send a Word file only if the job ad asks for one.", ask: ["Which CV design suits this job?", "Should I send a PDF or Word file?"] },
  6: { tip: "Set a follow-up date. A polite check-in about a week after applying is normal and often gets a reply.", ask: ["How should I follow up with the recruiter?", "Help me prepare for the interview"] },
};

export const STATUS_LABEL = { tailored: "Ready to send", applied: "Applied", interview: "Interview", offer: "Offer", rejected: "Not selected" };

export const GUEST_KEY = "gi_guest_check";
export const GUEST_CLAIM_KEY = "gi_guest_claim";

export const stepLabel = (n) => STEPS.find((s) => s.n === n)?.label || "";

export const keshContext = (detail) => window.dispatchEvent(new CustomEvent("kesh-context", { detail }));
